<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">购销合同</a>
        </span>
        <span v-else>购销合同</span>
      </a-col>
      <a-col :span="22" v-if="item !== null">
        <div :title="item.name">
          <span style="padding-left: 16px; display: block">
            <span class="desc">系统编号：{{ item.number }}</span>
            <span class="desc">类型：{{ item.type === 1? '采购合同' : '销售合同' }}</span>
            <span class="desc">合同号：{{ item.contract_number }}</span>
            <span class="desc">合同日期：{{ item.contract_date }}</span>
            <span class="desc">贸易类型：{{ tradeType(item.trade_type) }}</span>
            <span class="desc">客户：{{ item.client }}</span>
            <span class="desc">产品名称：
              <a-popover :title="'产品名称：' + item.product_name">
                <a>{{ item.product_name }}</a>
                <template slot="content">
                  <span class="desc" v-for="pp in item.product_parameter_list" :key="pp.id" style="display: block">
                    <span>{{ pp.name }}</span>
                    <span style="padding: 0px 5px">{{ dictionaries.trade_value_compare_symbol[pp.symbol] }}</span>
                    <span>{{ pp.standard_value }}</span>
                  </span>
                </template>
              </a-popover>
            </span>
            <span class="desc">数量和单位：{{ item.count }} {{ dictionaries.unit[item.unit] }}</span>
            <span class="desc" v-if="item.spec">规格型号：{{ item.spec }}</span>
            <span class="desc">贸易术语：{{ item.trade_term }}</span>
            <span class="desc">业务类型：{{ dictionaries.trade_contract_business_type[item.business_type] }}</span>
            <span class="desc" v-if="item.delivery_address">交货地：{{ item.delivery_address }}</span>
            <span class="desc" v-if="item.pricing_currency">计价币种：{{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '无' }}</span>
            <span class="desc" v-if="item.receive_pricing_currency">收款币种：{{ dictionaries.currency[item.receive_pricing_currency] ? dictionaries.currency[item.receive_pricing_currency] : '无' }}</span>
            <span class="desc">单价：
              <a-popover :title="dictionaries.unit_price_type[item.unit_price_type]">
                <template slot="content">
                  <div v-if="item.unit_price_type === 1">
                    <p>{{ item.fixed_price }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</p>
                  </div>
                  <div v-else-if="item.unit_price_type === 2" style="width: 800px">
                    <a-row :gutter="[16,16]">
                      <a-col :span="7">
                        升贴水：<span class="important-content">{{ item.premium_discount }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</span>
                      </a-col>
                      <a-col :span="7">
                        点价费：<span class="important-content">{{ item.price_fixing_fee }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</span>
                      </a-col>
                      <a-col :span="10">
                        转月费：<span class="important-content">{{ item.monthly_transfer_fee }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</span>
                      </a-col>
                    </a-row>
                    <div v-for="(futures_contract, index) in item.futures_contract_list" :key="index">
                      <a-row :gutter="[16,16]">
                        <a-col :span="7">
                          <span>{{ futuresContractPreTitle(index) }}</span>期货合约：<span class="important-content">{{ futures_contract.futures_contract }}</span>
                        </a-col>
                        <a-col :span="7">
                          <span>{{ futuresContractPreTitle(index) }}</span>锁价期限：<span class="important-content">{{ futures_contract.lock_up_date }}</span>
                        </a-col>
                        <a-col :span="10">
                          <span>{{ futuresContractPreTitle(index) }}</span>默认计价期：<span class="important-content">{{ futures_contract.pricing_period_start_date }}~{{ futures_contract.pricing_period_end_date }}</span>
                        </a-col>
                      </a-row>
                    </div>
                  </div>
                  <div v-else>
                    浮动参考依据：<span class="important-content">{{ item.floating_reference_basis }}</span>
                    价格参考期限：<span class="important-content">{{ item.price_reference_period_start_date }} ~ {{ item.price_reference_period_end_date }}</span>
                  </div>
                </template>
                <a>{{ dictionaries.unit_price_type[item.unit_price_type] }}</a>
              </a-popover>
            </span>
            <span class="desc">汇率类型：
              <a-popover :title="dictionaries.exchange_rate[item.exchange_rate]">
                <template slot="content">
                  <div v-if="item.exchange_rate === 1">
                    {{ item.fixed_exchange_rate }}
                  </div>
                  <div v-else-if="item.exchange_rate === 2" style="width: 400px;">
                    <a-row :gutter="[16,16]">
                      <a-col :span="8">
                        日期：{{ item.fixed_date_rate === '1970-01-01' ? '无' : item.fixed_date_rate }}
                      </a-col>
                      <a-col :span="16">
                        汇率定义方式：{{ item.exchange_rate_definition }}
                      </a-col>
                    </a-row>
                  </div>
                  <div v-else-if="item.exchange_rate === 3">
                    {{ item.unfixed_date_rate }}
                  </div>
                </template>
                <a>{{ dictionaries.exchange_rate[item.exchange_rate] }}</a>
              </a-popover>
            </span>
            <span class="desc">是否有临时单价：{{ dictionaries.is_temp_unit_price[item.temp_unit_price] }}</span>
            <span class="desc">是否有临时汇率：{{ dictionaries.is_has[item.is_temp_exchange_rate] }}</span>
            <span class="desc" v-if="item.temp_exchange_rate">临时汇率：{{ item.temp_exchange_rate }}</span>
            <span class="desc" v-if="item.quality_deduction_reason">质量扣款依据：{{ item.quality_deduction_reason }}</span>
            <span class="desc" v-if="item.payment_method > 0">预付款方式：
              <a-popover title="预付款">
                <template slot="content">
                  <div style="width: 400px;">
                    <a-row :gutter="[16,16]">
                      <a-col :span="12">
                        预付款金额：{{ item.pre_payment }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}
                      </a-col>
                      <a-col :span="12" v-if="item.pre_payment_date !== '1970-01-01'">
                        预付款日期：{{ item.pre_payment_date }}
                      </a-col>
                    </a-row>
                  </div>
                </template>
                <a>{{ '预付款'+ (dictionaries.trade_pre_payment_method[item.payment_method] || '') }}</a>
              </a-popover>
            </span>
            <span class="desc" v-if="item.balance_payment_method > 0">尾款方式：
              <a-popover title="尾款">
                <template slot="content">
                  <div style="width: 400px;">
                    <a-row :gutter="[16,16]">
                      <a-col :span="10">
                        尾款金额：<span class="important-content">{{ item.balance_payment }} {{ dictionaries.currency[item.pricing_currency] ? dictionaries.currency[item.pricing_currency] : '' }}</span>
                      </a-col>
                      <a-col :span="14">
                        <span v-if="item.trade_balance_payment_date_method === 1 && (item.balance_payment_date !== '1970-01-01')">
                          确定尾款日期：<span class="important-content">{{ item.balance_payment_date }}</span>
                        </span>
                        <span v-else-if="item.trade_balance_payment_date_method === 2">
                          承兑日后：<span class="important-content">{{ item.trade_balance_payment_days }} 天</span>
                        </span>
                        <span v-else>
                          <span v-if="item.unbalance_payment_date_desc">
                            不确定尾款日期：<span class="important-content">{{ item.unbalance_payment_date_desc }}</span>
                          </span>
                        </span>
                      </a-col>
                    </a-row>
                  </div>
                </template>
                <a>{{ (dictionaries.trade_balance_payment_method[item.balance_payment_method] || '') }}</a>
              </a-popover>
            </span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_sell_contract', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>
            <span class="desc" v-action:add>已存档：
              <a-popconfirm
                title="确定存档吗?"
                :disabled="item.is_archived"
                @confirm="() => handleArchived(item, 'sell_contract')">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.create_by">创建人：{{ item.create_by }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
            <span class="desc" v-if="item.version === 1">版本：V{{ item.version }}</span>
            <span class="desc" v-else-if="item.version > 1" @click="showDiffView(item)">
              版本：<a>V{{ item.version }}</a>
            </span>
            <sell-contract-record :sellContract="item" :visible="recordVisible" @close="recordVisible=false" v-if="recordVisible"/>
          </span>
          <span style="padding-left: 16px;" class="desc" v-if="item.remark">备注：{{ item.remark }}</span>
          <div style="padding-left: 16px;" v-if="(!item.is_archived && ((item.is_approval_needed && item.status !== 1) || (!item.is_approval_needed))) && edit">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'sell_contract')" v-if="!item.is_approval_needed && !item.is_expired">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'sell_contract')">
                <span v-if="!item.is_approval_needed || (item.is_approval_needed && item.status !== 1)">删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_sell_contract', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div>
            <a-collapse :bordered="false" style="padding: 1px;">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="1" header="关键点" :style="customStyle" v-if="item.key_point.length > 0">
                <p v-for="(point) in item.key_point" :key="point.id">{{ point.key }}：<span>{{ point.value }}</span></p>
              </a-collapse-panel>
              <a-collapse-panel key="2" header="附件" :style="customStyle" v-if="item.attachment.length > 0">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import SellContractRecord from '../modules/SellContractRecord'

export default {
  name: 'SellContractInfo',
  components: {
    SellContractRecord
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tradeType () {
      return (trade_type) => {
        switch (trade_type) {
          case 1:
            return '内贸'
          case 2:
            return '进口'
          case 3:
            return '出口'
        }
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      recordVisible: false,
      sellContractRecordList: [],
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      let path
      if (item.type === 2) {
        path = '/trade/sell_contract'
      } else {
        path = '/trade/purchase_contract'
      }
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    },
    showDiffView (item, type) {
      this.recordVisible = !this.recordVisible
      if (this.recordVisible) {
        this.sellContractRecordList = item.sell_contract_record_list
      }
    },
    closeDrawer () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
